/* CNQR — Global app JS: scroll animations, cart count refresh, toast helper */
(function () {
  'use strict';

  function init() {
    // Fade-in observer
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in-view');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.cnqr-fade, .cnqr-fade-stagger').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.cnqr-fade, .cnqr-fade-stagger').forEach(function (el) { el.classList.add('in-view'); });
    }

    // Refresh cart count
    refreshCartCount();
  }

  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.setAttribute('data-count', c.item_count);
      });
    }).catch(function () {});
  }

  function toast(msg, kind) {
    var t = document.querySelector('.cnqr-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'cnqr-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = 'cnqr-toast cnqr-toast--' + (kind || 'ok');
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  // Expose
  window.CNQR = { refreshCartCount: refreshCartCount, toast: toast };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
